import { createAsyncComponent } from '@mts-fe/utils';

export const AsyncRecordTable = createAsyncComponent(() => import('./src/AsyncRecordTable.vue'));
export const LogTable = createAsyncComponent(() => import('./src/LogTable.vue'));
